// Configuración del formulario de contacto (FormSubmit.co).
//
// FormSubmit acepta envíos ilimitados hacia cualquier cantidad de casillas: el
// destinatario viaja en la URL del endpoint, así que no hay claves que generar
// ni límite de direcciones.
//
// ACTIVACIÓN (una sola vez por casilla): la primera vez que se envía el
// formulario, FormSubmit manda un mail de confirmación a esa casilla. Hasta que
// alguien hace click en ese mail, los mensajes NO se entregan. Por eso hay que
// probar los 5 formularios una vez y confirmar los 5 correos.
//
// ALIAS (opcional, recomendado): junto con la confirmación, FormSubmit entrega
// un alias -una cadena aleatoria- para usar en lugar de la dirección real y no
// dejarla expuesta en el código. Cuando los tengas, cargalos en el .env; si la
// variable está vacía se usa el mail directamente y funciona igual.

const ALIAS_POR_CASILLA = {
  "info.williamcmorris@gmail.com": process.env.REACT_APP_FORM_INFO,
  "w.morrisjardin@gmail.com": process.env.REACT_APP_FORM_INICIAL,
  "primariomorris@gmail.com": process.env.REACT_APP_FORM_PRIMARIO,
  "recepcionsecundario@gmail.com": process.env.REACT_APP_FORM_SECUNDARIO,
  "secretariawcmnocturno@gmail.com": process.env.REACT_APP_FORM_NOCTURNO,
};

export function endpointDeFormulario(email) {
  const alias = ALIAS_POR_CASILLA[email];
  const destino = alias && alias.trim() ? alias.trim() : email;
  return `https://formsubmit.co/ajax/${encodeURIComponent(destino)}`;
}
